<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds-tablet is-half-desktop">
      <div v-if="routeName === 'reset-password'">
        <journeys-reset-password />
      </div>
      <div v-if="routeName === 'business-reset-password'">
        <business-reset-password />
      </div>
    </div>
  </div>
</template>

<script>
import router from 'router';
import { isLoggedIn } from 'router/helpers';

import BusinessResetPassword from 'components/auth/BusinessResetPassword';
import JourneysResetPassword from 'components/auth/JourneysResetPassword';
import UserTypeTabs from 'components/auth/UserTypeTabs';

export default {
  components: {
    BusinessResetPassword,
    JourneysResetPassword,
  },

  data() {
    return {};
  },

  beforeRouteEnter(to, from, next) {
    return isLoggedIn() ? next(false) : next();
  },

  computed: {
    routeName() {
      return router.currentRoute.name;
    },
  },

  methods: {},
};
</script>
